import api from './config';

/**
 * 获取设备课程表列表
 * @param {Object} params 查询参数
 */
export function getDeviceSchedules(params = {}) {
  return api.get('/device_schedule', { params });
}

/**
 * 获取设备课程表详情
 * @param {string} id 设备课程表ID
 */
export function getDeviceScheduleById(id) {
  return api.get(`/device_schedule/${id}`);
}

/**
 * 获取指定设备的最新课程表（当前登录用户）
 * @param {string} deviceId 设备ID（device_id）
 */
export function getLatestDeviceSchedule(deviceId) {
  return api.get('/device_schedule/latest', {
    params: { device_id: deviceId },
  });
}
